import React,{ useEffect} from 'react';
const Redirect = (props) => {
    const openInNewTab = url => {
      const  newWindow = window.open(url, '_blank', 'noopener,noreferrer');
      if(newWindow) newWindow.opener =null
      };
      useEffect(() =>{
        openInNewTab('http://exe-dashboard.advanceagro.net/truckscale');
      },[props])
    return ( 
        <>       
        </>
     );
}
 
export default Redirect;